/**
 * Content-switch for the 3x feature showcases (Figma 248:2 / 248:140).
 * The current item's progress bar is a CSS animation (--switch-duration); when it
 * finishes, the block advances to the next item. Hovering the list pauses the
 * animation (pure CSS); clicking an item switches to it and permanently disables
 * auto-advance for that block. Framework-free for the future React migration.
 */
export function initContentSwitches(): void {
  for (const block of document.querySelectorAll<HTMLElement>('[data-switch]')) {
    initBlock(block);
  }
}

function initBlock(block: HTMLElement): void {
  const buttons = [...block.querySelectorAll<HTMLButtonElement>('.switch-item')];
  const media = [...block.querySelectorAll<HTMLElement>('.feature__showcase > *')];
  const list = block.querySelector<HTMLElement>('.feature__switch-list');
  if (buttons.length === 0 || media.length !== buttons.length || !list) return;

  let current = Math.max(
    0,
    buttons.findIndex((button) => button.classList.contains('switch-item--current')),
  );

  const show = (index: number): void => {
    current = index;
    buttons.forEach((button, i) => button.classList.toggle('switch-item--current', i === index));
    media.forEach((el, i) => {
      el.hidden = i !== index;
    });
  };

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // the user took control — stop auto-advance for this block
      list.classList.add('feature__switch-list--manual');
      show(index);
    });
  });

  // the progress animation completing is the timer tick
  block.addEventListener('animationend', (event) => {
    if (event.animationName !== 'switch-progress') return;
    if (list.classList.contains('feature__switch-list--manual')) return;
    show((current + 1) % buttons.length);
  });
}
